import { render, staticRenderFns } from "./info-tree.vue?vue&type=template&id=2ffe3eb2&scoped=true"
import script from "./info-tree.vue?vue&type=script&lang=js"
export * from "./info-tree.vue?vue&type=script&lang=js"
import style0 from "./info-tree.vue?vue&type=style&index=0&id=2ffe3eb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe3eb2",
  null
  
)

export default component.exports